<template>
  <div
    v-if="compatibleWatchesCollections && compatibleWatchesCollections.length"
    class="straps-compatibility"
    :class="{ 'straps-compatibility--pdp': isPdp }"
  >
    <p class="straps-compatibility__title title" v-text="$t('Compatible with:')"></p>
    <ul class="straps-compatibility__list badges-wrapper">
      <li
        v-for="(label, index) in compatibleWatchesCollections"
        :key="index"
        class="straps-compatibility__item text font-badge -upper"
      >
        {{ label }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: `CompatibleWatchesCollections`,
  props: {
    compatibleWatchesCollections: {
      type: Array,
      default: () => []
    },
    isPdp: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

.straps-compatibility {
  --_title-font-size: 1rem;
  --_item-font-size: 1rem;
  --_margin-block: 1.5rem 0;
  --_badges-desktop-justify: center;

  margin-block: var(--_margin-block);

  &.straps-compatibility--pdp {
    --_title-font-size: 1.6rem;
    --_item-font-size: 1.4rem;
    --_margin-block: 2rem 3rem;
    --_badges-desktop-justify: flex-start;
  }

  @include bp(max md) {
    --_margin-block: 1rem 0;

    &.straps-compatibility--pdp {
      --_margin-block: 2rem 3rem;
    }
  }
  .straps-compatibility__title {
    color: var(--zenith-component-product-header-description);
    font-size: var(--_title-font-size);
    margin-bottom: 1rem;
    line-height: 1.2;
  }

  .badges-wrapper {
    margin-block: 1rem 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: var(--_badges-desktop-justify);
    gap: 0.4rem;
    list-style: none;
    padding: 0;

    @include bp(max md) {
      justify-content: center;
    }

    & > .font-badge {
      background-color: var(--zenith-component-product-item-badge);
      color: var(--zenith-component-product-item-badge-text);
      text-align: center;
      margin-top: 0;
      word-break: keep-all;
      padding: 0.5rem 1rem;
      font-size: var(--_item-font-size);
      line-height: 1.2;
    }
  }
}
</style>
